import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

export const login = async (pin) => {
  const response = await axios.post(
    `${API_URL}/auth/login`,
    { pin },
    { withCredentials: true }  // Important: sends/receives cookies
  );
  return response.data;
};

export const logout = async () => {
  const response = await axios.post(
    `${API_URL}/auth/logout`,
    {},
    { withCredentials: true }
  );
  return response.data;
};

export const checkAuth = async () => {
  const response = await axios.get(
    `${API_URL}/auth/check`,
    { withCredentials: true }
  );
  return response.data;
};
